module.exports = __webpack_public_path__ + "static/media/server.5a474616.png";